import { AngularSignaturePadModule } from "@almothafar/angular-signature-pad";
import { NgModule } from "@angular/core";

import { PermitCreateModule } from "../permit-create/permit-create.module";
import { PermitDetailsModule } from "../permit-details/permit-details.module";
import { PermitListModule } from "../permit-list/permit-list.module";
import { SharedModule } from "../shared/shared.module";
import { SubscriptionsModule } from "../subscriptions/subscriptions.module";
import { PermitNoAccessComponent } from "./components/permit-no-access/permit-no-access.component";
import { PermitReturnDelegationConfirmationModalComponent } from "./components/permit-return-delegation-confirmation-modal/permit-return-delegation-confirmation-modal.component";
import { PermitRootFilterModalComponent } from "./components/permit-root-filter-modal/permit-root-filter-modal.component";
import { PermitReturnDelegationModalComponent } from "./components/permit-return-delegation-modal/permit-return-delegation-modal.component";
import { PermitRootComponent } from "./components/permit-root.component";
import { PremiumInfoModalComponent } from "./components/premium-info-modal/premium-info-modal.component";
import { SignPersonModalComponent } from "./components/sign-person-modal/sign-person-modal.component";

@NgModule({
    imports: [
        AngularSignaturePadModule,
        PermitCreateModule,
        PermitDetailsModule,
        PermitDetailsModule,
        PermitListModule,
        SharedModule,
        SubscriptionsModule,
    ],
    exports: [],
    declarations: [
        PermitNoAccessComponent,
        PermitRootComponent,
        SignPersonModalComponent,
        PermitRootFilterModalComponent,
        PermitReturnDelegationModalComponent,
        PermitReturnDelegationConfirmationModalComponent,
        PremiumInfoModalComponent,
    ],
    providers: [],
})
export class PermitRootModule {}
